<div class="container-full pb-4 sessions-tab distribute-tab"
  *ngIf="!!sessions?.length; else noSessions">
  <div class="row">
    <div [ngClass]="{ 'col-md-4' : !viewOnly , 'col-md-6' : viewOnly  }">
      <mat-selection-list [multiple]="false"
        class="distribute-tree mt-3"
        [(ngModel)]="selectedId"
        (ngModelChange)="selectSession($event)">
        <mat-list-option *ngFor="let session of sessions; index as i; trackBy: trackByFn"
          [selected]="selectedSession?.id == session.id"
          [value]="session.id"
          class="distribute-tree__list-option">
          <div fxLayout="row"
            fxLayoutAlign="space-between">
            <span>
              <span class="d-block"
                style="margin-bottom: -3px">
                {{ session.name | translate }} -
                <small style="font-size: 12px"
                  class="text-muted">
                  {{ 'SESSIONS.number' | translate }} : {{ session.number }}
                </small>
              </span>
              <small style="font-size: 12px"
                class="text-muted">
                {{ session.sessionFrom | localizedDate }} -
                {{ session.sessionTo | localizedDate }}
              </small>
            </span>

            <app-member-length-icon *ngIf="session?.visitMembers?.length"
              [members]="session?.visitMembers"></app-member-length-icon>
          </div>
        </mat-list-option>
      </mat-selection-list>
    </div>
    <div [ngClass]="{ 'col-md-8' : !viewOnly , 'col-md-6' : viewOnly  }">
      <app-team-members *ngIf="selectedSession"
        [visitInfo]="visitInfo"
        [userRole]="userRole"
        [selectedMembers]="selectedSession.visitMembers"
        (targetChanges)="targetChanges($event)"
        [viewOnly]="viewOnly"
        [disabled]="disabled"></app-team-members>
    </div>
  </div>
</div>

<ng-template #noSessions>
  <div class="pb-4 sessions-tab distribute-tab text-center">
    <div class="tab-no-data">
      <h4>{{ 'ERRORS.NoDataFound' | translate }}</h4>
    </div>
  </div>
</ng-template>
